export const MMSL_URL = 'https://makemysitelive.com';
export const REMOTEGIG_URL = 'https://remotegig.in';

const UTM_SOURCE = 'csc-export-tool';

/**
 * Tags cross-promotion visits from this property, with placement in utm_content.
 */
export const withUtm = (baseUrl, placement) => {
  const url = new URL(baseUrl);
  url.searchParams.set('utm_source', UTM_SOURCE);
  url.searchParams.set('utm_medium', 'banner');
  url.searchParams.set('utm_campaign', 'cross-promo');
  url.searchParams.set('utm_content', placement);
  return url.toString();
};
